export default __webpack_public_path__ + "../img/35412ace03f42c030dd328b03c5db9e0.png";